import { ResendDoctorInvite } from 'domain/usecases/doctor/resendDoctorInvite'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteResendDoctorInvite implements ResendDoctorInvite {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  resend(params: ResendDoctorInvite.Params): Promise<ResendDoctorInvite.Model> {
    return this.doctorRepository.resendDoctorInvite(params)
  }
}
